import React, { useState, useLayoutEffect } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from 'moment';

const MaisLidas = ({ title, dark, total }) => {
    const [dados, setDados] = useState([])
    const noticias = useSelector(state => state.gazeta.noticiasMaisLidas)

    useLayoutEffect(() => {
        // se injetar direto a MaterialTable buga o redux
        let ajuste = noticias.slice(0,total).map((item, key) => {
            var now = moment(new Date()); //todays date
            var end = moment(item.data, 'YYYY-MM-DDTHH:mm.Z'); // another date
            var duration = moment.duration(now.diff(end));
            var diferencaMin = duration.asMinutes();
            let tempo = ""
            if (diferencaMin < 60) tempo = `Há ${parseInt(diferencaMin)} ${parseInt(diferencaMin) > 1 ? "minutos" : "minuto"} `
            else if (diferencaMin < 1440) tempo = `Há ${parseInt(diferencaMin / 60)} ${parseInt(diferencaMin / 60) > 1 ? "horas" : "hora"}`
            else if (diferencaMin > 1440) tempo = `Há ${parseInt(diferencaMin / 1440)} ${parseInt(diferencaMin / 1440) > 1 ? "dias" : "dia"}`
            return Object.assign(
                {},
                item,
                { tempo },
                { data: moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("DD/MM/YYYY HH:mm") },
                { link: `/noticia/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("YYYY")}/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("MM")}/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("DD")}/${item.chave}` }
            )
        })
        Promise.all(ajuste).then(values => setDados(values))

    }, [noticias, total])

    return (
        <div className="widget tab_widgets mb30">
            <h2 className="widget-title">{title ? title : 'Most View'}</h2>
            <div className="post_type2_carousel multipleRowCarousel nav_style1">
                {dados.map((item, key) => (
                    <div key={key} className="carousel_items">
                        <div className="single_post widgets_small widgets_type4">
                            <div className="post_img number">
                                <h2>{key + 1}</h2>
                            </div>
                            <div className="single_post_text">
                                <div className="meta2">
                                    {item.categorias ? item.categorias.map((item, key, row) =>
                                        <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                            {`${item.nome}`}
                                            {key + 1 !== row.length ? " /" : null}
                                        </Link>
                                    ) : null}
                                    <Link to={`${item.link}`}>{item.tempo}</Link>
                                </div>
                                <h4><Link to={`${item.link}`}>{item.titulo}</Link></h4>
                                <div className="space-15" />
                                {dark ? <div className="border_white" /> : <div className="border_black" />}
                            </div>
                        </div>
                        <div className="space-15" />
                    </div>
                ))}

            </div>
        </div>
    );
};

export default MaisLidas;